import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateOrderRequestSchema,
  TCreateOrderResponseSchema,
} from "./createOrder.schema";

export const createOrder = (axios: IAxiosInstance) => {
  return async (data: TCreateOrderRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateOrderResponseSchema>
    >(`/orders`, data);

    return response.data;
  };
};
